import { bindSubtaskReordering } from "./subtask-reorder-controller.ts";
import { bindTaskRowSwipes, type TaskRowSwipeCapabilities } from "./task-row-swipe-controller.ts";

export interface ReorderBinding {
  bind(root: ParentNode): void;
}

export interface TaskInteractionRuntimeCapabilities<Snapshot, Field extends string> {
  document: Document;
  listReordering: ReorderBinding;
  boardReordering: ReorderBinding;
  rowSwipes: TaskRowSwipeCapabilities<Snapshot, Field>;
  hapticFeedback(): void;
  subtaskUndo(message: string, restore: () => void): void;
}

export function createTaskInteractionRuntime<Snapshot, Field extends string>(capabilities: TaskInteractionRuntimeCapabilities<Snapshot, Field>) {
  return {
    bindListReordering: (): void => capabilities.listReordering.bind(capabilities.document),
    bindBoardReordering: (): void => capabilities.boardReordering.bind(capabilities.document),
    bindRowSwipes: (): void => bindTaskRowSwipes(capabilities.document, capabilities.rowSwipes),
    bindSubtaskReordering: (): void => bindSubtaskReordering(capabilities.document, { hapticFeedback: capabilities.hapticFeedback, undo: capabilities.subtaskUndo }),
  };
}
